<template>
  <!-- <div> -->



      <div class="row mt-2">
    <!-- <div class="col-12 p-4">
      <TitleAndBorderC>מבער Napoli</TitleAndBorderC>
    </div> -->
    <div class="col-md-6 p-3 left-side center-top border-left">
      <div class="w-100 center-top">
        <!-- <div class="col center-all"> -->
          <div class="block-text">
            <TitleAndBorderR>התנור שכבש את ארה"ב מגיע לישראל</TitleAndBorderR>
          <p>טאבון הפיצה <span>נאפולי</span> הושק בקיקסטרטר ב-2017, וגייס את מלוא הסכום תוך 24 שעות בלבד. תוך חודשים אחדים הברטלו כבש גם את שוק תנורי הפיצה בארה"ב, עד שכל הטאבונים אזלו מהמלאי למשך שבועות ארוכים.</p>
          <p>הברטלו מתלהט לחום מדהים של +500°C, ויחד עם אבן האפייה המיוחדת שלו הוא מציע חוויה איטלקית אמיתית. רק 90 שניות, ויש לכם פיצה גורמה. לבית, לקמפינג, לערבי משפחה וחברים – ה-<span>Bertello&#8209;Napoli</span> שלכם יהיה במרכז העניינים.</p>
          </div>
        <!-- </div> -->
      </div>
      <!-- <div class="row">
        <div class="col center-all">
          <img data-aos="fade-up" src="../assets/ass4.jpg" alt="">
        </div>
      </div> -->

    </div>
    <div class="col-md-6 p-3 left-side center-top border-left">
      <div class=" center-top w-100">
        <!-- <div class="col center-all"> -->
          <div class="block-text">
            <!-- <h2>מבער גז</h2> -->
             <TitleAndBorderR>בטיחות ואחריות</TitleAndBorderR>
            <ul>
            <li>טאבון <span>הברטלו</span> בטוח לחלוטין לשימוש והוא בעל תקן אירופאי מחמיר <img src="../assets/ass21.png" alt=""></li>
            <li>בעל יציבה מושלמת: 4 רגליים מתקפלות חזקות במיוחד</li>
            <li>מתנייד בקלות, ניתן להנחה על כל משטח</li>
            <li>דפנות כפולות ומבודדות, לשמירת החום בתוך תא האפייה</li>
            <li>שנה אחריות על המבער</li>
          </ul>
          </div>
        <!-- </div> -->
      </div>
      <!-- <div class="row">
        <div class="col center-all">
          <img data-aos="fade-up" src="../assets/ass4.jpg" alt="">
        </div>
      </div> -->

    </div>


   
  </div>



    <!-- <div class="row mt-5">
      <div class="col part-shulders center-all">
        <div class="block-text">
          <TitleAndBorderC>התנור שכבש את ארה"ב מגיע לישראל</TitleAndBorderC>
          <p>טאבון הפיצה <span>נאפולי</span> הושק בקיקסטרטר ב-2017, וגייס את מלוא הסכום תוך 24 שעות בלבד. תוך חודשים אחדים הנאפולי כבש גם את שוק תנורי הפיצה בארה"ב, עד שכל הטאבונים אזלו מהמלאי למשך שבועות ארוכים.</p>
          <p>הנאפולי מתלהט לחום מדהים של +500°C, ויחד עם אבן האפייה המיוחדת שלו הוא מציע חוויה איטלקית אמיתית. רק 90 שניות, ויש לכם פיצה גורמה. לבית, לקמפינג, לערבי משפחה וחברים – ה-<span>Napoli</span> שלכם יהיה במרכז העניינים.</p>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
  export default {
    name: 'SoWhy',
    props: {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* .left-side img {
    width: 25%;
  } */

  .block-text {
    width: 75%;
    /* text-align: center; */
  }

   li img {
      width: 40px;
    }


  @media (max-width: 767.98px) {
    /* .left-side img {
      width: 100%;
    } */

    .block-text {
      width: 100%;
    }

    .block-text span {
      font-weight: bold;
      font-size: 18px
    }

   

  }
</style>